import { render, staticRenderFns } from "./TopluHacizTalepDuzenleForm.vue?vue&type=template&id=2d3171f6&scoped=true"
import script from "./TopluHacizTalepDuzenleForm.vue?vue&type=script&lang=ts"
export * from "./TopluHacizTalepDuzenleForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3171f6",
  null
  
)

export default component.exports